const at = name => `[data-tour-scope="newsletters-list"] [data-tour="${name}"]`;
const visible = selector => {
	const element = document.querySelector(selector);
	return !!element && element.getClientRects().length > 0;
};
const pause = () => new Promise(resolve => setTimeout(resolve, 0));

async function openMenu(activator, probe) {
	await pause();
	if (!visible(probe)) document.querySelector(activator)?.click();
}

export function stopNewslettersTour() {
	for (const [activator, probe] of [[at('export'), at('export-csv')], [at('add'), at('add-email')], [at('row-menu'), at('row-delete')]]) {
		if (visible(probe)) document.querySelector(activator)?.click();
	}
}

export function createNewslettersTourSteps() {
	return [
		{ body: 'Qui gestisci i contatti iscritti alla newsletter e controlli quando e da quale dispositivo si sono registrati.', key: 'intro', placement: 'bottom', target: at('tutorial'), title: 'Iscritti newsletter' },
		{ body: 'Cerca un contatto per nome, email o altri dati disponibili, quindi premi Invio o la lente.', key: 'search', placement: 'bottom', target: at('search'), title: 'Cercare un iscritto' },
		{ before: () => openMenu(at('export'), at('export-csv')), body: 'Il menu di esportazione scarica l’elenco filtrato in formato CSV oppure Excel.', key: 'export', placement: 'left', target: at('export-csv'), timeout: 250, title: 'Esportare i contatti' },
		{ before: () => openMenu(at('add'), at('add-email')), body: "Il piu' apre la pagina per inserire a mano un nuovo contatto, con un tutorial tutto suo.", key: 'add', placement: 'left', target: at('add-email'), timeout: 250, title: 'Nuovo iscritto' },
		{ body: 'La tabella mostra stato, date di creazione e registrazione, anagrafica, IP e user agent.', key: 'table', placement: 'top', target: at('table'), title: 'Elenco iscritti' },
		{ body: 'L’interruttore abilita o sospende il contatto nelle attività newsletter.', key: 'status', missing: 'skip', placement: 'right', target: at('status'), title: 'Stato iscrizione' },
		{ before: () => openMenu(at('row-menu'), at('row-delete')), body: 'I tre pallini aprono le voci della riga: Modifica apre la pagina del contatto, Elimina lo cancella dopo una richiesta di conferma.', key: 'row-menu', placement: 'right', target: at('row-delete'), timeout: 250, title: 'Eliminare un contatto' },
	];
}
